import { Box, Flex, Heading, Text } from '@dapperlabs/core-fe';
import { breakpoints, useMediaQuery } from 'src/theme';
import { StackV2Icon } from 'src/theme/Icon';

import { PacksInDropList } from './components';
import { ActiveDropSinglePack } from './components/ActiveDropSinglePack';
interface ActiveDropProps {
  description;
  distributions: any[];
  title: string;
}

export const ActiveDrop = ({
  title,
  description,
  distributions,
}: ActiveDropProps) => {
  const [isMdUp] = useMediaQuery(`screen and (min-width: ${breakpoints.md})`);

  return distributions?.length === 1 ? (
    <ActiveDropSinglePack distribution={distributions[0]} />
  ) : (
    <Box
      as='section'
      flexDirection='column'
      display='flex'
      mb={20}
      mx={[4, 4, 4, 4, 24]}
      pt={{ base: 16, md: 32 }}
    >
      <Box
        mb={8}
        p={6}
        bg='black'
        border='1px solid #393B45'
        borderRadius='20px'
      >
        <Heading
          as='h2'
          fontFamily='poster'
          fontSize={['5xl', '6xl']}
          fontWeight='500'
          lineHeight={1}
        >
          <Flex alignItems='flex-start' justifyContent='space-between'>
            <Box as='span'>{title}</Box>
            {isMdUp && <StackV2Icon width={6} height={6} />}
          </Flex>
        </Heading>
        <Text mt={4} color='gray.100' fontSize={['md', 'lg']} lineHeight='1.4'>
          {description}
        </Text>
      </Box>
      <PacksInDropList distributions={distributions} isActiveDrop />
    </Box>
  );
};
